import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SessionTimerService } from '../../../core/services/session-timer.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-assist-underwrite',
    templateUrl: './assist-underwrite.component.html',
    styleUrls: ['./assist-underwrite.component.scss']
})
export class AssistUnderwriteComponent implements OnInit {
    public redirect: string = '';

    constructor(private sessionTimerService: SessionTimerService, private spinner: NgxSpinnerService, private route: ActivatedRoute) { }

    public ngOnInit(): void {
        this.spinner.hide();
        this.sessionTimerService.SetShowTimer(false);
        this.sessionTimerService.stopTimer();

        this.route.queryParamMap.subscribe(params => {
            var redirect = params.get('redirect');
            if (redirect && redirect !== 'undefined') {
                this.redirect = redirect;
            }
        });
    }

    public goBack(): void {
        window.location.replace(this.redirect);
    }

}
